import { IAppState } from "../../../app/appTypes"
import { ISharedAsset } from "../../../features/caseSharedAssets/state/caseSharedAssetsTypes"

const EMPTY_ARRAY: string[] = []

export const getCaseAssetsCanBeSharedWithUser = (state: IAppState, caseId: string, userId: string): string[] => {
  if (!state.entities.sharedAssets?.canBeSharedWithUserByUserId?.[userId]) return EMPTY_ARRAY
  return state.entities.sharedAssets.canBeSharedWithUserByUserId[userId][caseId] || EMPTY_ARRAY
}

export const getSharedAssetById = (state: IAppState, assetId: string): ISharedAsset =>
state.entities.sharedAssets.byId[assetId]
